import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NModal } from "naive-ui";
import { ref, watch } from "vue";

interface IProps {
  isOpen: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertPopup',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const show = ref(props.isOpen);
watch(props, (val) => {
  show.value = val.isOpen;
});
function onClose() {
  emit(`close`, !props.isOpen);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NModal), {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    preset: "dialog",
    class: "custom-modal",
    type: "warning",
    "show-icon": false,
    title: "This Investment Still Waiting Approval",
    "positive-text": "Confirm",
    "negative-text": "",
    onMaskClick: onClose,
    onClose: onClose,
    onPositiveClick: onClose,
    onNegativeClick: onClose
  }, {
    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("div", null, [
        _createElementVNode("p", { class: "text-left" }, [
          _createTextVNode(" Status "),
          _createElementVNode("b", null, "Waiting Approval"),
          _createTextVNode(" can’t view my invetsment detail ")
        ])
      ], -1)
    ]))]),
    _: 1
  }, 8, ["show"]))
}
}

})